import * as React from 'react';

/** `.vide` du kit : ce qu'on montre quand il n'y a encore rien. */
export function EmptyState({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <div className="vide">
      <p>{children}</p>
    </div>
  );
}
